/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";

import { useFormContext } from "react-hook-form";

import { Box, Card, Tabs } from "@origin-digital/ods-core";

import { IISolarBatteryOutlookResponse } from "@/contract/generated/electrify-v1";

import { solarBatteryOutlook as content } from "./content.json";
import { SingleSystem } from "./SingleSystem";
import { useMediaQuery, useTheme } from "@mui/material";
import { StyledTab } from "@/components/StyledTab";

type SolarBatteryOutlookWrapperProps = {
  solarBatteryOutlook: Array<IISolarBatteryOutlookResponse>;
  medianSizeIndex: number;
};

export const SolarBatteryOutlookWrapper = ({
  solarBatteryOutlook,
  medianSizeIndex,
}: SolarBatteryOutlookWrapperProps) => {
  const solarBattery = solarBatteryOutlook || [];
  const { setValue } = useFormContext();
  const [tabIndex, setTabIndex] = useState(medianSizeIndex);

  const theme = useTheme();
  const isSmDown = useMediaQuery(theme.breakpoints.down("sm"));

  useEffect(() => {
    setTabIndex(medianSizeIndex);
    setValue("selectedSystemSize", solarBattery[medianSizeIndex]?.size ?? 0);
  }, [solarBattery, medianSizeIndex]);

  return (
    <Card
      paddingYSpecific="none"
      paddingXSpecific="none"
      data-id={content.testId.wrapper}
    >
      <Box paddingBottom={["xlarge", "xxlarge"]}>
        {solarBattery.length ? (
          solarBattery.length > 1 ? (
            <Tabs
              value={tabIndex}
              size="small"
              variant="fullWidth"
              data-id={content.testId.tabs}
            >
              {solarBattery.map((solarBatterySystem, idx) => (
                <StyledTab
                  key={`${solarBatterySystem.size}-${idx}`}
                  muiProps={{
                    onClick: () => {
                      setTabIndex(idx);
                      setValue("selectedSystemSize", solarBatterySystem.size);
                    },
                  }}
                  className={isSmDown ? "mobile-tab" : ""}
                  label={`${solarBatterySystem.size}kW`}
                >
                  <SingleSystem
                    solarBatterySystem={solarBatterySystem}
                    key={`${content.testId.singleSystem}-${idx}`}
                  />
                </StyledTab>
              ))}
            </Tabs>
          ) : (
            <SingleSystem solarBatterySystem={solarBattery[0]} />
          )
        ) : (
          <></>
        )}
      </Box>
    </Card>
  );
};
